import { render } from "./NumberActionsCard.vue?vue&type=template&id=30c3505e&scoped=true"
import script from "./NumberActionsCard.vue?vue&type=script&lang=js"
export * from "./NumberActionsCard.vue?vue&type=script&lang=js"

import "./NumberActionsCard.vue?vue&type=style&index=0&id=30c3505e&scoped=true&lang=scss"

import exportComponent from "C:\\Bohdan\\telesim_test\\telesim-admin-panel\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30c3505e"]])

export default __exports__